module.exports = __webpack_public_path__ + "static/media/explore.482f243d.png";